import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { S as StyledLink, a as StyledIcon } from './Link.styles-Dln9dnCk.js';
import { u as useTextAncestorSize } from '../HasTextAncestorContext/HasTextAncestorContext-DP5pzSWh.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { j as externalLink } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { u as useSurface } from '../SurfaceProvider/SurfaceProvider-qDGZSFCj.js';

/**
 * Derives the color of the link by checking if the link is on a background color that
 * requires inverted, text, or default link colors.
 */
const useColor = colorProp => {
  const {
    isInverted
  } = useSurface();
  if (isInverted) {
    return 'inverted';
  }
  return colorProp || 'default';
};
/**
 * Link
 */
const Link = ({
  anchorRef,
  children,
  href,
  color,
  external = false,
  size,
  taktId,
  taktValue,
  ...rest
}) => {
  const derivedColor = useColor(color);
  const derivedSize = useTextAncestorSize(size);
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('link')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(StyledLink, _extends({}, getDataTaktAttributes(), external && {
    rel: 'noopener noreferrer'
  }, rest, {
    $color: derivedColor,
    $size: derivedSize,
    href: href,
    ref: anchorRef
  }), children, external && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "\xA0", /*#__PURE__*/React__default.createElement(StyledIcon, {
    type: externalLink
  }))));
};
Link.displayName = 'Link';

export { Link as L };
//# sourceMappingURL=Link-DE16ej9A.js.map
